import {memo, ReactNode} from 'react';
import styled from 'styled-components';

interface CardDetailsProps {
  children: ReactNode;
}

export const CardDetails = memo(({children}: CardDetailsProps) => {
  return <DetailsWrapper>{children}</DetailsWrapper>;
});

const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
